import { render, staticRenderFns } from "./OwnTokens.vue?vue&type=template&id=073683c7&scoped=true&"
import script from "./OwnTokens.vue?vue&type=script&lang=js&"
export * from "./OwnTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073683c7",
  null
  
)

export default component.exports